import Vue from 'vue'

/* const files = require.context("./", true, /\.svg$/i)

files.keys().map((key) => Vue.component( "i-" + key .split("/") .pop() .split(".")[0], files(key).default)) */

import iLoader from '@/assets/icons/loader_salamander.svg'
Vue.component('i-loader', iLoader)

import iSun from '@/assets/icons/sun_salamander.svg'
Vue.component('i-sun', iSun)

import iRepeat from '@/assets/icons/repeat_salamander.svg'
Vue.component('i-repeat', iRepeat)

import iUser from '@/assets/icons/user_salamander.svg'
Vue.component('i-user', iUser)

import iNotes from '@/assets/icons/notes_salamander.svg'
Vue.component('i-notes', iNotes)

import iMedical from '@/assets/icons/medical_salamander.svg'
Vue.component('i-medical', iMedical)

import iLock from '@/assets/icons/lock_salamander.svg'
Vue.component('i-lock', iLock)

import iCheck from '@/assets/icons/check_salamander.svg'
Vue.component('i-check', iCheck)

import iCheckmark from '@/assets/icons/checkmark_salamander.svg'
Vue.component('i-checkmark', iCheckmark)

import iCross from '@/assets/icons/cross_salamander.svg'
Vue.component('i-cross', iCross)

import iSort from '@/assets/icons/sort_salamander.svg'
Vue.component('i-sort', iSort)

import iWakeup from '@/assets/icons/wakeup_salamander.svg'
Vue.component('i-wakeup', iWakeup)

import iToBed from '@/assets/icons/to-bed_salamander.svg'
Vue.component('i-to-bed', iToBed)

import iToSleep from '@/assets/icons/to-sleep_salamander.svg'
Vue.component('i-to-sleep', iToSleep)

import iGetOut from '@/assets/icons/get-out_salamander.svg'
Vue.component('i-get-out', iGetOut)

import iHat from '@/assets/icons/hat_salamander.svg'
Vue.component('i-hat', iHat)

import iBell from '@/assets/icons/bell_salamander.svg'
Vue.component('i-bell', iBell)

import iBulb from '@/assets/icons/bulb_salamander.svg'
Vue.component('i-bulb', iBulb)

import iClock from '@/assets/icons/clock_salamander.svg'
Vue.component('i-clock', iClock)

import iBack from '@/assets/icons/back_salamander.svg'
Vue.component('i-back', iBack)

import iForward from '@/assets/icons/forward_salamander.svg'
Vue.component('i-forward', iForward)

import iArrowDown from '@/assets/icons/arrow-down_salamander.svg'
Vue.component('i-arrow-down', iArrowDown)

import iSettings from '@/assets/icons/3-dots_salamander.svg'
Vue.component('i-settings', iSettings)

import iCog from '@/assets/icons/cog_salamander.svg'
Vue.component('i-cog', iCog)

import iCalendar from '@/assets/icons/calendar_salamander.svg'
Vue.component('i-calendar', iCalendar)

import iTrash from '@/assets/icons/trash_salamander.svg'
Vue.component('i-trash', iTrash)

import imageNoAccess from '@/assets/icons/undraw_auth_salamander.svg'
Vue.component('image-no-access', imageNoAccess)

import iClockRollback from '@/assets/icons/clock_rollback_salamander.svg'
Vue.component('i-clock-rollback', iClockRollback)

import iInfo from '@/assets/icons/info_salamander.svg'
Vue.component('i-info', iInfo)

import imageSleeping from '@/assets/icons/sleeping_salamander.svg'
Vue.component('image-sleeping', imageSleeping)

import checkCircle from '@/assets/icons/check_circle_salamander.svg'
Vue.component('i-check-circle', checkCircle)

